import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux' 
import { Navigate } from 'react-router-dom'
import { withRouter } from 'globals/utils' 
import Loaded from 'components/loaded'
import RolloverStart from './components/rolloverStart'
import RolloverComplete from './components/rolloverComplete'
import RolloverEvents from './components/rolloverEvents'
import { getRollover, processRollover } from 'data/bmc/rollover/action'

import './style.css' 

class RolloverPage extends React.Component {
  constructor(props) {
    super(props)

    const { events } = this.props  
    let rollTypes = []
    if (!!events && events.length>0) {
      rollTypes = events.reduce((r, e) => { 
        if (!r.includes(e.type)) { r.push(e.type)}
        return r
      },[])
    }
    this.state = {
      errors: {},
      currentPos: -1,
      rollTypes,
      loading: false,
      confirmOpen: false,
    }
  }

  componentDidMount() {
    if (!this.props.events) {
      this.setState({loading: true})
      this.props.getRollover().catch(err => {
        console.log('error loading rollover:', err)
      })
    } else if (this.props.events.length === 0) {  
      this.setState({skip: true})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.events !== this.props.events)) {
      const { events } = this.props
      if (!!events) { 
        if (events.length > 0) { 
          const rollTypes = events.reduce((r, e) => { 
            if (!r.includes(e.type)) { r.push(e.type)}
            return r
          },[])
          this.setState({rollTypes, loading: false})
        } else {
          this.props.navigate("/home")
        }
      }
    }
  }
  onStart = () => {
    this.setState({currentPos: 0})
  }
  onNext = () => {
    let { currentPos, rollTypes } = this.state 
    if (currentPos >= (rollTypes.length-1)) {
      //Post Rollover
      this.setState({loading: true})
      const { events } = this.props  
      this.props.processRollover(events).then(()=>{
        this.setState({loading: false, currentPos: -2})
      }).catch(err=>{
        console.log('error posting rollover:', err)
      }) 
    } else {
      currentPos +=1    
      this.setState({currentPos})
    }
  }
  onPrev = () => {
    let { currentPos } = this.state
    if (currentPos > 0) { currentPos -=1 }
    this.setState({currentPos})
  }
  onFinish = (url) => {
    if (url) this.props.navigate(url)
  }
  renderEvent = () => {
    const { currentPos } = this.state  
    switch (currentPos) {
      case -1:
        return <RolloverStart onClick={this.onStart}/>
      case -2:
          return <RolloverComplete onFinish={this.onFinish}/>
      default: 
        const { events } = this.props  
        if (!events) return null
        const { rollTypes } = this.state 
        const evts = events.filter( e => e.type === rollTypes[currentPos])
        return <RolloverEvents events={evts} type={rollTypes[currentPos]} pos={currentPos} last={rollTypes.length-1} onNext={this.onNext} onPrev={this.onPrev} />
    }
  }

  render() {
    const { loading, skip, currentPos } = this.state 
    if (skip) return <Navigate to='/thisyear' />
    return (
      <Loaded loading={loading}>
        {(currentPos>-1 || !loading) && this.renderEvent()} 
      </Loaded>
    )
  }
}

RolloverPage.propTypes = {
  users: PropTypes.object
}

function mapStateToProps(state) {
  return {
    users: state.shared_data.user,
    settings: state.shared_data.bmc.settings,
    events: state.shared_data.bmc.rollover
  }
}

export default withRouter(connect(mapStateToProps, { getRollover, processRollover})(RolloverPage));